<template>
  <font-awesome-icon
    v-if="loading"
    :spin="true"
    :icon="['fas', 'spinner']"
    class="icon alt"
  />
  <p v-else-if="nextAvailability"> {{ nextAvailability | withTimeZone | format(format) }} </p>
  <p v-else> None </p>
</template>

<script>
import CounselorClient from '@/api/CounselorClient';
import moment from 'moment';

export default {
  props: {
    counselorId:{
      type: Number, 
      require: true,
    },
    format: {
      type: String, 
      require: false,
      default: () => "MMMM Do, h:mm a z"
    }
  },
  data() {
    return {
      counselorClient: new CounselorClient(this.$http),
      loading: true,
      nextAvailability: null,
    }
  },
  async mounted(){
    try {
      const response = await this.counselorClient.getCounselorNextAvailability(this.counselorId);
      if(response.nextAvailable)
        this.nextAvailability = moment(response.nextAvailable);
    } catch(ex) {
      console.error(ex);
    } finally {
      this.loading = false;
    }
  },
}
</script>

<style>

</style>